module.exports = __webpack_public_path__ + "img/view.125ac1d7.svg";